import classes from "./Details.module.css";


function Details(){

   const cartIcon = "./icon-cart.svg";

 return (
    <span className={classes.Details}>
    <section className={classes.Preview}>perfume</section>

    <h1 className={classes.Heading}>Gabrielle Essence Eau De Parfum</h1> 
  
   <p className={classes.Paragraph}>A floral, solar and voluptuous interpretation composed by Olivier Polge, 
    Perfumer-Creator for the House of CHANEL.</p> 
  
   <section className={classes.PriceSection}>
    <h1>$149.99</h1>
    <span>$169.99</span>
    </section> 
  
   <button className={classes.AddIteamButton}><img src={cartIcon} alt="" className={classes.cartIcon} /> Add to Cart</button>
    </span>
 );
}
export default Details;